export default {
  "button": "_button_kft5i_5",
  "skeleton": "_skeleton_kft5i_53",
  "primary": "_primary_kft5i_58",
  "merge": "_merge_kft5i_59",
  "success": "_success_kft5i_60",
  "danger": "_danger_kft5i_61",
  "upgrade": "_upgrade_kft5i_62",
  "warning": "_warning_kft5i_63",
  "user-primary": "_user-primary_kft5i_103",
  "user-secondary": "_user-secondary_kft5i_116",
  "secondary": "_secondary_kft5i_132",
  "blank": "_blank_kft5i_215",
  "nested": "_nested_kft5i_216",
  "active": "_active_kft5i_233",
  "inverted": "_inverted_kft5i_238",
  "link": "_link_kft5i_247",
  "pill": "_pill_kft5i_266",
  "close": "_close_kft5i_300",
  "xsmall": "_xsmall_kft5i_313",
  "small": "_small_kft5i_318",
  "medium": "_medium_kft5i_323",
  "large": "_large_kft5i_328",
  "xlarge": "_xlarge_kft5i_333",
  "disabled": "_disabled_kft5i_360"
};import "ni:sha-256;t32urB82gg1uQLeW1RC6N4cuIvtKzmTrUHcpWcqVeQc";